module.exports = __webpack_public_path__ + "static/media/success-day.b7276860.svg";